// extracted by mini-css-extract-plugin
export default {"icon":"index__icon__RP4fj"};